import { Box, Card, CardContent, CardMedia, Chip, Stack, Typography } from "@mui/material";
import { ShowButton } from "react-admin";
import { Cargo } from "../../models/Cargo";
import { TruckLength, TruckType } from "../../utils/truck-utils";

const formatDateTime = (value: string | null | undefined) => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);
  const pad = (n: number) => String(n).padStart(2, "0");

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
    date.getSeconds()
  )}`;
};

const formatCargoPrice = (record: Cargo) => {
  if (record.single_price != null) {
    return `${record.single_price} 元/车`;
  }

  if (record.unit_price != null) {
    return `${record.unit_price} 元/吨`;
  }

  return "-";
};

export const SmallCargoCard: React.FC<Cargo> = (record) => {
  return (
    <Card
      sx={{
        minHeight: 144,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        position: "relative",
        boxShadow: "none",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Box display="flex">
        <CardMedia
          component="img"
          image={record.image}
          alt={record.name}
          style={{
            width: "104px",
            height: "104px",
            padding: "8px",
            objectFit: "cover",
          }}
        />
        <Box display="flex" flexDirection="column">
          <CardContent sx={{ flex: "1 0 auto", p: 1, "&:last-child": { pb: 1 } }}>
            <Stack direction="row" spacing={0.75} alignItems="center" sx={{ mb: 0.5 }}>
              <Chip
                size="small"
                label={record.continuous ? "长期" : "单次"}
                color={record.continuous ? "primary" : "default"}
                variant={record.continuous ? "filled" : "outlined"}
              />
              <Typography variant="caption" fontWeight={600}>
                #{record.id}
              </Typography>
            </Stack>
            <Typography variant="body2" fontWeight={600}>
              {record.name}
            </Typography>
            <br />
            <Typography variant="caption" color="textSecondary">
              {formatCargoPrice(record)}
            </Typography>
            <br />
            <Typography variant="caption" color="textSecondary">
              上架：{formatDateTime(record.publish_at)}
            </Typography>
            <br />
            {record.truck_lengths &&
              record.truck_lengths.length > 0 &&
              record.truck_types &&
              record.truck_types.length > 0 && (
                <Typography variant="caption" color="textSecondary">
                  {`车长: ${record.truck_lengths
                    .map(TruckLength)
                    .join(", ")} | 车型: ${record.truck_types
                    .map(TruckType)
                    .join(", ")}`}
                </Typography>
              )}
          </CardContent>
        </Box>
      </Box>
      <Box display="flex" flexDirection="column" maxHeight={100}>
          <Box display="flex">
          <Typography variant="caption">
          订金：{record.deposit ? `${record.deposit / 100}元` : "面议"}
          </Typography>
          <Box sx={{ flex: 1 }}/>
          <ShowButton/>
          </Box>
          <Typography variant="caption">
          发货地：{record.from.province}{record.from.city}{record.from.district}
          </Typography>
          <Typography variant="caption">
          收货地：{record.to.province}{record.to.city}{record.to.district}
          </Typography>
      </Box>
      
    </Card>
  );
};
